import type { TowerDesign } from "@/game/towerSpec";
/**
 * Newington 170 ft guyed lattice tower (Berlin Tpke, Newington CT), from
 * reference_towers/02_engineering_drawings/CT_Newington_BerlinTpke_guyed_lattice_170ft_structural.pdf.
 * EXACT: 170 ft (51.82 m), 3x (triangular) guyed, face width 3.420 ft at top,
 * tapered (wider) at base → top circumradius 0.602 m, base ~0.79 m (est. taper).
 * TIA-222-?, 95 mph, Exposure B, 1.00" ice. Guy attach heights → standard spacing.
 */
export const design: TowerDesign = {
  id: "guyed-newington-170ft",
  name: "Guyed Lattice (Newington 170 ft)",
  description: "Real 170 ft triangular guyed lattice, Newington CT (95 mph, Exp B).",
  author: "reference: CT Newington Berlin Tpke 170 ft SA",
  spec: {
    type: "guyed",
    height: 51.82,
    stack: { faces: 3, panels: 34, baseRadius: 0.79, topRadius: 0.602,
      legSection: "legHeavy", braceSection: "braceHeavy", legMaterial: "a572", braceMaterial: "a572", bracing: "X" },
    guys: [0.3, 0.55, 0.78, 0.96].map((f, i) => ({ atHeightFrac: f, anchorRadius: 22 + i * 7, section: "guy38", material: "guyStrand", pretensionStrain: 0.001 })),
    foundation: { soil: "stiff-clay", base: { type: "pier", width: 0.6, diameter: 0.6, depth: 1.5, concrete: "c20" }, anchor: { type: "deadman", width: 1.5, diameter: 0.6, depth: 2, concrete: "c20" } },
  },
};
